const PROVIDER_META: Record<string, { name: string; scope: 'federal' | 'state' | 'county' | 'municipal' }> = {
  congress_gov: { name: 'Congress.gov', scope: 'federal' },
  alabama: { name: 'Alabama Legislature', scope: 'state' },
  arizona: { name: 'Arizona Legislature', scope: 'state' },
  california: { name: 'California Legislature', scope: 'state' },
  connecticut: { name: 'Connecticut General Assembly', scope: 'state' },
  dc: { name: 'Council of the District of Columbia', scope: 'state' },
  ilga: { name: 'Illinois General Assembly', scope: 'state' },
  wisconsin: { name: 'Wisconsin Legislature', scope: 'state' },
  cook_county_board: { name: 'Cook County Board of Commissioners', scope: 'county' },
  fpdcc_board: { name: 'Forest Preserve District of Cook County', scope: 'county' },
  kane_county_board: { name: 'Kane County Board', scope: 'county' },
  lake_county_board: { name: 'Lake County Board', scope: 'county' },
  harris_county_tx: { name: 'Harris County Commissioners Court', scope: 'county' },
  bexar_county_tx: { name: 'Bexar County Commissioners Court', scope: 'county' },
  travis_county_commissioners_court: { name: 'Travis County Commissioners Court', scope: 'county' },
  tarrant_county_tx: { name: 'Tarrant County Commissioners Court', scope: 'county' },
  fort_bend_county_tx: { name: 'Fort Bend County Commissioners Court', scope: 'county' },
  montgomery_county_tx: { name: 'Montgomery County Commissioners Court', scope: 'county' },
  medina_county_tx: { name: 'Medina County Commissioners Court', scope: 'county' },
  waller_county_tx: { name: 'Waller County Commissioners Court', scope: 'county' },
  comal_county_tx: { name: 'Comal County Commissioners Court', scope: 'county' },
  collin_county_tx: { name: 'Collin County Commissioners Court', scope: 'county' },
  dallas_county_tx: { name: 'Dallas County Commissioners Court', scope: 'county' },
  denton_county_tx: { name: 'Denton County Commissioners Court', scope: 'county' },
  kaufman_county_tx: { name: 'Kaufman County Commissioners Court', scope: 'county' },
  rockwall_county_tx: { name: 'Rockwall County Commissioners Court', scope: 'county' },
  bastrop_county_tx: { name: 'Bastrop County Commissioners Court', scope: 'county' },
  hays_county_tx: { name: 'Hays County Commissioners Court', scope: 'county' },
  williamson_county_tx: { name: 'Williamson County Commissioners Court', scope: 'county' },
  johnson_county_tx: { name: 'Johnson County Commissioners Court', scope: 'county' },
  parker_county_tx: { name: 'Parker County Commissioners Court', scope: 'county' },
  wise_county_tx: { name: 'Wise County Commissioners Court', scope: 'county' },
  el_paso_county_tx: { name: 'El Paso County Commissioners Court', scope: 'county' },
  aransas_county_tx: { name: 'Aransas County Commissioners Court', scope: 'county' },
  san_patricio_county_tx: { name: 'San Patricio County Commissioners Court', scope: 'county' },
  kleberg_county_tx: { name: 'Kleberg County Commissioners Court', scope: 'county' },
  nueces_county_tx: { name: 'Nueces County Commissioners Court', scope: 'county' },
  randall_county_tx: { name: 'Randall County Commissioners Court', scope: 'county' },
  webb_county_tx: { name: 'Webb County Commissioners Court', scope: 'county' },
  lubbock_county_tx: { name: 'Lubbock County Commissioners Court', scope: 'county' },
  potter_county_tx: { name: 'Potter County Commissioners Court', scope: 'county' },
  aurora_city_council: { name: 'Aurora City Council', scope: 'municipal' },
  naperville_city_council: { name: 'Naperville City Council', scope: 'municipal' },
  buffalo_grove_village_board: { name: 'Buffalo Grove Village Board', scope: 'municipal' },
  lombard_village_board: { name: 'Lombard Village Board', scope: 'municipal' },
  orland_park_village_board: { name: 'Orland Park Village Board', scope: 'municipal' },
  palatine_village_council: { name: 'Palatine Village Council', scope: 'municipal' },
  mount_prospect_village_board: { name: 'Mount Prospect Village Board', scope: 'municipal' },
  arlington_heights_village_board: { name: 'Arlington Heights Village Board', scope: 'municipal' },
  wheeling_village_board: { name: 'Wheeling Village Board', scope: 'municipal' },
  hoffman_estates_village_board: { name: 'Hoffman Estates Village Board', scope: 'municipal' },
  joliet_city_council: { name: 'Joliet City Council', scope: 'municipal' },
  chicago_city_council: { name: 'Chicago City Council', scope: 'municipal' },
  rockford_city_council: { name: 'Rockford City Council', scope: 'municipal' },
  maine: { name: 'Maine Legislature', scope: 'state' },
  bangor_city_council: { name: 'Bangor City Council', scope: 'municipal' },
  lewiston_city_council: { name: 'Lewiston City Council', scope: 'municipal' },
  south_portland_city_council: { name: 'South Portland City Council', scope: 'municipal' },
  manchester_board_of_mayor_and_aldermen: { name: 'Manchester Board of Mayor and Aldermen', scope: 'municipal' },
  dover_nh: { name: 'Dover City Council', scope: 'municipal' },
  portsmouth_nh: { name: 'Portsmouth, NH City Council', scope: 'municipal' },
  hillsborough_county_nh: { name: 'Hillsborough County Board of Commissioners', scope: 'county' },
  merrimack_county_nh: { name: 'Merrimack County Board of Commissioners', scope: 'county' },
  rockingham_county_nh: { name: 'Rockingham County Board of Commissioners', scope: 'county' },
  strafford_county_nh: { name: 'Strafford County Board of Commissioners', scope: 'county' },
  androscoggin_county_commissioners: { name: 'Androscoggin County Board of Commissioners', scope: 'county' },
  cumberland_county_commissioners: { name: 'Cumberland County Board of Commissioners', scope: 'county' },
  penobscot_county_commissioners: { name: 'Penobscot County Board of Commissioners', scope: 'county' },
  portland_city_council: { name: 'Portland City Council', scope: 'municipal' },
  baltimore_city_council: { name: 'Baltimore City Council', scope: 'municipal' },
  providence_city_council_ri: { name: 'Providence City Council', scope: 'municipal' },
  pawtucket_ri: { name: 'Pawtucket City Council', scope: 'municipal' },
  warwick_ri: { name: 'Warwick City Council', scope: 'municipal' },
  cranston_ri: { name: 'Cranston City Council', scope: 'municipal' },
  boise_city_id: { name: 'Boise City Council', scope: 'municipal' },
  nampa_id: { name: 'Nampa City Council', scope: 'municipal' },
  kootenai_county_id: { name: 'Kootenai County Board of County Commissioners', scope: 'county' },
  idaho_falls_id: { name: 'Idaho Falls City Council', scope: 'municipal' },
  ada_county_id: { name: 'Ada County Board of Commissioners', scope: 'county' },
  coeur_dalene_id: { name: "Coeur d'Alene City Council", scope: 'municipal' },
  canyon_county_id: { name: 'Canyon County Board of Commissioners', scope: 'county' },
  bonneville_county_id: { name: 'Bonneville County Board of Commissioners', scope: 'county' },
  annapolis_city_council: { name: 'Annapolis City Council', scope: 'municipal' },
  bowie_city_council: { name: 'Bowie City Council', scope: 'municipal' },
  gaithersburg_md: { name: 'Gaithersburg City Council', scope: 'municipal' },
  burlington_vt: { name: 'Burlington City Council', scope: 'municipal' },
  montpelier_vt: { name: 'Montpelier City Council', scope: 'municipal' },
  charleston_wv: { name: 'Charleston WV City Council', scope: 'municipal' },
  huntington_wv: { name: 'Huntington WV City Council', scope: 'municipal' },
  cabell_county_wv: { name: 'Cabell County Commission', scope: 'county' },
  kanawha_county_wv: { name: 'Kanawha County Commission', scope: 'county' },
  south_burlington_vt: { name: 'South Burlington City Council', scope: 'municipal' },
  rutland_vt: { name: 'Rutland City Board of Aldermen', scope: 'municipal' },
  greenville_city_council: { name: 'Greenville City Council', scope: 'municipal' },
  prince_georges_county_council: { name: "Prince George's County Council", scope: 'county' },
  anne_arundel_county_md: { name: 'Anne Arundel County Council', scope: 'county' },
  boston_city_council: { name: 'Boston City Council', scope: 'municipal' },
  somerville_city_council: { name: 'Somerville City Council', scope: 'municipal' },
  lowell_city_council: { name: 'Lowell City Council', scope: 'municipal' },
  cambridge_city_council_ma: { name: 'Cambridge City Council', scope: 'municipal' },
  springfield_ma: { name: 'Springfield City Council', scope: 'municipal' },
  worcester_ma: { name: 'Worcester City Council', scope: 'municipal' },
  springfield_mo: { name: 'Springfield City Council', scope: 'municipal' },
  stlouis_mo: { name: 'St. Louis Board of Aldermen', scope: 'municipal' },
  ann_arbor_city_council: { name: 'Ann Arbor City Council', scope: 'municipal' },
  warren_mi: { name: 'Warren City Council', scope: 'municipal' },
  flint_mi: { name: 'Flint City Council', scope: 'municipal' },
  sterling_heights_mi: { name: 'Sterling Heights City Council', scope: 'municipal' },
  macomb_county_mi: { name: 'Macomb County Board of Commissioners', scope: 'county' },
  wayne_county_mi: { name: 'Wayne County Commission', scope: 'county' },
  washtenaw_county_mi: { name: 'Washtenaw County Board of Commissioners', scope: 'county' },
  genesee_county_commissioners: { name: 'Genesee County Board of Commissioners', scope: 'county' },
  clinton_county_commissioners: { name: 'Clinton County Board of Commissioners', scope: 'county' },
  kent_county_commissioners: { name: 'Kent County Board of Commissioners', scope: 'county' },
  grand_rapids_city_commission_mi: { name: 'Grand Rapids Authorities & Commissions', scope: 'municipal' },
  lansing_mi: { name: 'Lansing City Council', scope: 'municipal' },
  detroit_city_council: { name: 'Detroit City Council', scope: 'municipal' },
  minnesota: { name: 'Minnesota Legislature', scope: 'state' },
  saint_paul_city_council: { name: 'Saint Paul City Council', scope: 'municipal' },
  minneapolis_mn: { name: 'Minneapolis City Council', scope: 'municipal' },
  rochester_mn: { name: 'Rochester City Council', scope: 'municipal' },
  bloomington_mn: { name: 'Bloomington City Council', scope: 'municipal' },
  eagan_mn: { name: 'Eagan City Council', scope: 'municipal' },
  southaven_board_of_aldermen: { name: 'Southaven Mayor & Board of Aldermen', scope: 'municipal' },
  desoto_county_board_of_supervisors: { name: 'DeSoto County Board of Supervisors', scope: 'county' },
  hinds_county_ms: { name: 'Hinds County Board of Supervisors', scope: 'county' },
  eaton_county_commissioners: { name: 'Eaton County Board of Commissioners', scope: 'county' },
  clay_county_mo: { name: 'Clay County Commission', scope: 'county' },
  greene_county_mo: { name: 'Greene County Commission', scope: 'county' },
  cass_county_mo: { name: 'Cass County Commission, MO', scope: 'county' },
  boone_county_mo: { name: 'Boone County Commission, MO', scope: 'county' },
  platte_county_mo: { name: 'Platte County Commission, MO', scope: 'county' },
  kansas: { name: 'Kansas State Legislature', scope: 'state' },
  louisiana: { name: 'Louisiana State Legislature', scope: 'state' },
  kansas_city_council: { name: 'Kansas City Council', scope: 'municipal' },
  jackson_county_legislature: { name: 'Jackson County Legislature', scope: 'county' },
  columbia_city_council: { name: 'Columbia City Council', scope: 'municipal' },
  independence_city_council: { name: 'Independence City Council', scope: 'municipal' },
  las_vegas_nv: { name: 'Las Vegas City Council', scope: 'municipal' },
  reno_nv: { name: 'Reno City Council', scope: 'municipal' },
  henderson_nv: { name: 'Henderson City Council', scope: 'municipal' },
  sioux_falls_sd: { name: 'Sioux Falls City Council', scope: 'municipal' },
  aberdeen_sd: { name: 'Aberdeen City Council', scope: 'municipal' },
  brookings_sd: { name: 'Brookings City Council', scope: 'municipal' },
  lincoln_county_sd: { name: 'Lincoln County Board of Commissioners, SD', scope: 'county' },
  pennington_county_sd: { name: 'Pennington County Board of Commissioners', scope: 'county' },
  brown_county_sd: { name: 'Brown County, SD Board of County Commissioners', scope: 'county' },
  minnehaha_county_sd: { name: 'Minnehaha County Board of County Commissioners', scope: 'county' },
  brookings_county_sd: { name: 'Brookings County Commission', scope: 'county' },
  newark_municipal_council: { name: 'Newark Municipal Council', scope: 'municipal' },
  albuquerque_municipal_council: { name: 'Albuquerque Municipal Council', scope: 'municipal' },
  las_cruces_nm: { name: 'Las Cruces City Council', scope: 'municipal' },
  santa_fe_county_nm: { name: 'Santa Fe County Board of County Commissioners', scope: 'county' },
  bernalillo_county_nm: { name: 'Bernalillo County Board of County Commissioners', scope: 'county' },
  dona_ana_county_nm: { name: 'Doña Ana County Board of County Commissioners', scope: 'county' },
  sarpy_county_ne: { name: 'Sarpy County Board of Commissioners', scope: 'county' },
  lancaster_county_ne: { name: 'Lancaster County Board of Commissioners', scope: 'county' },
  hall_county_ne: { name: 'Hall County Board of Commissioners', scope: 'county' },
  douglas_county_ne: { name: 'Douglas County Board of Commissioners', scope: 'county' },
  yonkers_city_council: { name: 'Yonkers City Council', scope: 'municipal' },
  charlotte_city_council: { name: 'Charlotte City Council', scope: 'municipal' },
  winston_salem_city_council: { name: 'Winston-Salem City Council', scope: 'municipal' },
  greensboro_nc: { name: 'Greensboro, NC City Council', scope: 'municipal' },
  raleigh_nc: { name: 'Raleigh, NC City Council', scope: 'municipal' },
  durham_nc: { name: 'Durham City Council', scope: 'municipal' },
  durham_county_board: { name: 'Durham County Board of Commissioners', scope: 'county' },
  cumberland_county_board: { name: 'Cumberland County Board of Commissioners', scope: 'county' },
  wake_county_nc: { name: 'Wake County Board of Commissioners', scope: 'county' },
  orange_county_nc: { name: 'Orange County Board of County Commissioners', scope: 'county' },
  mecklenburg_county_nc: { name: 'Mecklenburg County Board of Commissioners', scope: 'county' },
  guilford_county_nc: { name: 'Guilford County Board of Commissioners', scope: 'county' },
  forsyth_county_nc: { name: 'Forsyth County Board of Commissioners', scope: 'county' },
  clark_county_nv: { name: 'Clark County Board of Commissioners', scope: 'county' },
  washoe_county_nv: { name: 'Washoe County Board of Commissioners', scope: 'county' },
  columbus_city_council: { name: 'Columbus City Council', scope: 'municipal' },
  cleveland_city_council: { name: 'Cleveland City Council', scope: 'municipal' },
  cincinnati_city_council: { name: 'Cincinnati City Council', scope: 'municipal' },
  toledo_city_council: { name: 'Toledo City Council', scope: 'municipal' },
  dayton_oh: { name: 'Dayton City Commission', scope: 'municipal' },
  hamilton_county_oh: { name: 'Hamilton County Board of Commissioners', scope: 'county' },
  passaic_county_board: { name: 'Passaic County Board of County Commissioners', scope: 'county' },
  westchester_county_ny: { name: 'Westchester County Board of Legislators', scope: 'county' },
  albany_county_ny: { name: 'Albany County Legislature', scope: 'county' },
  erie_county_ny: { name: 'Erie County Legislature', scope: 'county' },
  albany_common_council: { name: 'Albany Common Council', scope: 'municipal' },
  buffalo_ny: { name: 'Buffalo Common Council', scope: 'municipal' },
  syracuse_ny: { name: 'Syracuse Common Council', scope: 'municipal' },
  new_york_city_ny: { name: 'New York City Council', scope: 'municipal' },
  fargo_city_commission: { name: 'Fargo City Commission', scope: 'municipal' },
  bismarck_city_commission: { name: 'Bismarck City Commission', scope: 'municipal' },
  burleigh_county_nd: { name: 'Burleigh County Commission', scope: 'county' },
  cass_county_nd: { name: 'Cass County Board of Commissioners', scope: 'county' },
  charleston_city_sc: { name: 'Charleston City Council', scope: 'municipal' },
  rock_hill_sc: { name: 'Rock Hill, SC City Council', scope: 'municipal' },
  minot_city_council: { name: 'Minot City Council', scope: 'municipal' },
  grand_forks_nd: { name: 'Grand Forks, ND City Council', scope: 'municipal' },
  grand_forks_county_nd: { name: 'Grand Forks County, ND County Commission', scope: 'county' },
  monroe_county_ny: { name: 'Monroe County Legislature', scope: 'county' },
  oklahoma_city_ok: { name: 'Oklahoma City Council', scope: 'municipal' },
  oklahoma_county_ok: { name: 'Oklahoma County Board of Commissioners', scope: 'county' },
  cleveland_county_ok: { name: 'Cleveland County Board of Commissioners', scope: 'county' },
  pottawatomie_county_ok: { name: 'Pottawatomie County Board of County Commissioners', scope: 'county' },
  osage_county_ok: { name: 'Osage County Board of County Commissioners', scope: 'county' },
  wagoner_county_ok: { name: 'Wagoner County Board of County Commissioners', scope: 'county' },
  rogers_county_ok: { name: 'Rogers County Board of County Commissioners', scope: 'county' },
  tulsa_county_ok: { name: 'Tulsa County Board of County Commissioners', scope: 'county' },
  norman_ok: { name: 'Norman City Council', scope: 'municipal' },
  salem_city_council: { name: 'Salem City Council', scope: 'municipal' },
  san_antonio_tx: { name: 'San Antonio City Council', scope: 'municipal' },
  austin_tx: { name: 'Austin City Council', scope: 'municipal' },
  houston_tx: { name: 'Houston City Council', scope: 'municipal' },
  phoenix_az: { name: 'Phoenix City Council', scope: 'municipal' },
  scottsdale_az: { name: 'Scottsdale City Council', scope: 'municipal' },
  pima_county_az: { name: 'Pima County Board of Supervisors', scope: 'county' },
  maricopa_county_az: { name: 'Maricopa County Board of Supervisors', scope: 'county' },
  mesa_az: { name: 'Mesa City Council', scope: 'municipal' },
  fort_worth_tx: { name: 'Fort Worth City Council', scope: 'municipal' },
  fortlauderdale_fl: { name: 'Fort Lauderdale City Commission', scope: 'municipal' },
  pinellas_fl: { name: 'Pinellas County Board of County Commissioners', scope: 'county' },
  broward_county_fl: { name: 'Broward County Commission', scope: 'county' },
  miami_dade_county_fl: { name: 'Miami-Dade County Board of County Commissioners', scope: 'county' },
  miami_fl: { name: 'City of Miami City Commission', scope: 'municipal' },
  tallahassee_fl: { name: 'Tallahassee City Commission', scope: 'municipal' },
  st_petersburg_fl: { name: 'St. Petersburg City Council', scope: 'municipal' },
  tampa_fl: { name: 'Tampa City Council', scope: 'municipal' },
  hillsborough_county_fl: { name: 'Hillsborough County Board of County Commissioners', scope: 'county' },
  leon_county_fl: { name: 'Leon County, FL Board of County Commissioners', scope: 'county' },
  orange_county_fl: { name: 'Orange County Board of County Commissioners', scope: 'county' },
  dallas_city_tx: { name: 'Dallas City Council', scope: 'municipal' },
  delaware: { name: 'Delaware General Assembly', scope: 'state' },
  gresham_city_council: { name: 'Gresham City Council', scope: 'municipal' },
  eugene_or: { name: 'Eugene City Council', scope: 'municipal' },
  oregon: { name: 'Oregon Legislative Assembly', scope: 'state' },
  philadelphia_city_council: { name: 'Philadelphia City Council', scope: 'municipal' },
  pittsburgh_city_council: { name: 'Pittsburgh City Council', scope: 'municipal' },
  allentown_city_council: { name: 'Allentown City Council', scope: 'municipal' },
  york_county_sc: { name: 'York County Council', scope: 'county' },
  nashville_metropolitan_council: { name: 'Nashville Metropolitan Council', scope: 'municipal' },
  natrona_county_wy: { name: 'Natrona County Board of County Commissioners', scope: 'county' },
  campbell_county_wy: { name: 'Campbell County Board of County Commissioners', scope: 'county' },
  casper_wy: { name: 'Casper City Council', scope: 'municipal' },
  gillette_wy: { name: 'Gillette City Council', scope: 'municipal' },
  norfolk_va: { name: 'Norfolk City Council', scope: 'municipal' },
  chesapeake_va: { name: 'Chesapeake City Council', scope: 'municipal' },
  newport_news_va: { name: 'Newport News City Council', scope: 'municipal' },
  alexandria_va: { name: 'Alexandria City Council', scope: 'municipal' },
  virginia_beach_va: { name: 'Virginia Beach City Council', scope: 'municipal' },
  richmond_va: { name: 'Richmond City Council', scope: 'municipal' },
  shelby_county_tn: { name: 'Shelby County Board of Commissioners', scope: 'county' },
  knoxville_tn: { name: 'Knoxville City Council', scope: 'municipal' },
  los_angeles_ca: { name: 'Los Angeles City Council', scope: 'municipal' },
  los_angeles_county_ca: { name: 'Los Angeles County Board of Supervisors', scope: 'county' },
  sacramento_county_ca: { name: 'Sacramento County Board of Supervisors', scope: 'county' },
  san_jose_ca: { name: 'San Jose City Council', scope: 'municipal' },
  fresno_county_ca: { name: 'Fresno County Board of Supervisors', scope: 'county' },
  fresno_ca: { name: 'Fresno City Council', scope: 'municipal' },
  bridgeport_ct: { name: 'Bridgeport City Council', scope: 'municipal' },
  hartford_ct: { name: 'Hartford City Council', scope: 'municipal' },
  new_haven_ct: { name: 'New Haven Board of Aldermen', scope: 'municipal' },
  nashua_board_of_aldermen: { name: 'Nashua Board of Aldermen', scope: 'municipal' },
  concord_city_council: { name: 'Concord City Council', scope: 'municipal' },
  norwalk_ct: { name: 'Norwalk Common Council', scope: 'municipal' },
  stamford_ct: { name: 'Stamford Board of Representatives', scope: 'municipal' },
  denver_co: { name: 'Denver City Council', scope: 'municipal' },
  colorado_springs_co: { name: 'Colorado Springs City Council', scope: 'municipal' },
  fort_collins_co: { name: 'Fort Collins City Council', scope: 'municipal' },
  larimer_county_co: { name: 'Larimer County Board of County Commissioners', scope: 'county' },
  el_paso_county_co: { name: 'El Paso County Board of County Commissioners', scope: 'county' },
  adams_county_co: { name: 'Adams County Board of County Commissioners', scope: 'county' },
  arapahoe_county_co: { name: 'Arapahoe County Board of County Commissioners', scope: 'county' },
  douglas_county_co: { name: 'Douglas County Board of County Commissioners', scope: 'county' },
  san_francisco_ca: { name: 'San Francisco Board of Supervisors', scope: 'municipal' },
  san_diego_county_ca: { name: 'San Diego County Board of Supervisors', scope: 'county' },
  san_diego_ca: { name: 'San Diego City Council', scope: 'municipal' },
  santa_clara_county_ca: { name: 'Santa Clara County Board of Supervisors', scope: 'county' },
  alameda_county_ca: { name: 'Alameda County Board of Supervisors', scope: 'county' },
  kern_county_ca: { name: 'Kern County Board of Supervisors', scope: 'county' },
  orange_county_ca: { name: 'Orange County Board of Supervisors', scope: 'county' },
  riverside_county_ca: { name: 'Riverside County Board of Supervisors', scope: 'county' },
  stanislaus_county_ca: { name: 'Stanislaus County Board of Supervisors', scope: 'county' },
  san_bernardino_county_ca: { name: 'San Bernardino County Board of Supervisors', scope: 'county' },
  san_joaquin_county_ca: { name: 'San Joaquin County Board of Supervisors', scope: 'county' },
  ventura_county_ca: { name: 'Ventura County Board of Supervisors', scope: 'county' },
  utah: { name: 'Utah State Legislature', scope: 'state' },
  slc_ut: { name: 'Salt Lake City Council', scope: 'municipal' },
  westvalleycity_ut: { name: 'West Valley City Council', scope: 'municipal' },
  saltlakecounty_ut: { name: 'Salt Lake County Council', scope: 'county' },
  ogden_ut: { name: 'Ogden City Council', scope: 'municipal' },
  weber_county_ut: { name: 'Weber County Commission', scope: 'county' },
  seattle_wa: { name: 'Seattle City Council', scope: 'municipal' },
  bellevue_wa: { name: 'Bellevue City Council', scope: 'municipal' },
  tacoma_wa: { name: 'Tacoma City Council', scope: 'municipal' },
  spokane_wa: { name: 'Spokane City Council', scope: 'municipal' },
  spokane_county_wa: { name: 'Spokane County Board of Commissioners', scope: 'county' },
  vancouver_wa: { name: 'Vancouver City Council', scope: 'municipal' },
  kingcounty_wa: { name: 'Metropolitan King County Council', scope: 'county' },
  pierce_county_wa: { name: 'Pierce County Council', scope: 'county' },
  milwaukee_common_council: { name: 'Milwaukee Common Council', scope: 'municipal' },
  madison_common_council: { name: 'Madison Common Council', scope: 'municipal' },
  dane_county_board: { name: 'Dane County Board', scope: 'county' },
  dupage_county_board: { name: 'DuPage County Board', scope: 'county' },
  will_county_il: { name: 'Will County Board', scope: 'county' },
  winnebago_county_il: { name: 'Winnebago County, IL County Board', scope: 'county' },
  kendall_county_il: { name: 'Kendall County, IL County Board', scope: 'county' },
  sangamon_county_il: { name: 'Sangamon County, IL County Board', scope: 'county' },
  racine_wi: { name: 'Racine Common Council', scope: 'municipal' },
  greenbay_wi: { name: 'Green Bay Common Council', scope: 'municipal' },
  kenosha_wi: { name: 'Kenosha Common Council', scope: 'municipal' },
  milwaukee_county_wi: { name: 'Milwaukee County Board of Supervisors', scope: 'county' },
  brown_county_wi: { name: 'Brown County Board of Supervisors, WI', scope: 'county' },
  washington_county_wi: { name: 'Washington County Board of Supervisors', scope: 'county' },
  waukesha_county_wi: { name: 'Waukesha County Board of Supervisors', scope: 'county' },
  alaska: { name: 'Alaska Legislature', scope: 'state' },
  anchorage_ak: { name: 'Anchorage Assembly', scope: 'municipal' },
  fairbanks_north_star_borough_ak: { name: 'Fairbanks North Star Borough Assembly', scope: 'county' },
  juneau_ak: { name: 'Juneau Assembly', scope: 'municipal' },
  birmingham_al: { name: 'Birmingham City Council', scope: 'municipal' },
  jefferson_county_al: { name: 'Jefferson County Commission', scope: 'county' },
  mobile_al: { name: 'Mobile City Council', scope: 'municipal' },
  mobile_county_al: { name: 'Mobile County Commission', scope: 'county' },
  tuscaloosa_al: { name: 'Tuscaloosa City Council', scope: 'municipal' },
  tuscaloosa_county_al: { name: 'Tuscaloosa County Commission', scope: 'county' },
  shelby_county_al: { name: 'Shelby County Commission', scope: 'county' },
  montgomery_county_al: { name: 'Montgomery County Commission, AL', scope: 'county' },
  sedgwick_county_ks: { name: 'Sedgwick County Board of Commissioners', scope: 'county' },
  overland_park_ks: { name: 'Overland Park City Council', scope: 'municipal' },
  lawrence_ks: { name: 'Lawrence City Commission', scope: 'municipal' },
  douglas_county_ks: { name: 'Douglas County Commission', scope: 'county' },
  johnson_county_ks: { name: 'Johnson County Board of County Commissioners', scope: 'county' },
  olathe_ks: { name: 'Olathe City Council', scope: 'municipal' },
  kansas_city_ks: { name: 'Kansas City KS Board of Commissioners', scope: 'municipal' },
  wichita_ks: { name: 'Wichita City Council', scope: 'municipal' },
  topeka_ks: { name: 'Topeka City Council', scope: 'municipal' },
  shawnee_county_ks: { name: 'Shawnee County Board of County Commissioners', scope: 'county' },
  arkansas: { name: 'Arkansas General Assembly', scope: 'state' },
  fayetteville_ar: { name: 'Fayetteville City Council', scope: 'municipal' },
  washington_county_ar: { name: 'Washington County (Quorum Court)', scope: 'county' },
  pulaski_county_ar: { name: 'Pulaski County Quorum Court', scope: 'county' },
  fayetteville_nc: { name: 'Fayetteville City Council', scope: 'municipal' },
  newark_de: { name: 'Newark City Council', scope: 'municipal' },
  wilmington_de: { name: 'Wilmington, DE City Council', scope: 'municipal' },
  dover_de: { name: 'Dover City Council', scope: 'municipal' },
  new_castle_county_de: { name: 'New Castle County, DE County Council', scope: 'county' },
  new_orleans_la: { name: 'New Orleans City Council', scope: 'municipal' },
  baton_rouge_la: { name: 'Baton Rouge Metropolitan Council', scope: 'municipal' },
  lafayette_la: { name: 'Lafayette Consolidated Government', scope: 'municipal' },
  bossier_parish_la: { name: 'Bossier Parish Police Jury', scope: 'county' },
  caddo_parish_la: { name: 'Caddo Parish Commission', scope: 'county' },
  savannah_ga: { name: 'Savannah City Council', scope: 'municipal' },
  athens_clarke_county_ga: { name: 'Athens-Clarke County Mayor & Commission', scope: 'county' },
  augusta_ga: { name: 'Augusta Commission', scope: 'county' },
  columbus_ga: { name: 'Columbus GA City Council', scope: 'municipal' },
  chatham_county_ga: { name: 'Chatham County Board of Commissioners', scope: 'county' },
  dekalb_county_ga: { name: 'DeKalb County Board of Commissioners', scope: 'county' },
  fulton_county_ga: { name: 'Fulton County Board of Commissioners', scope: 'county' },
  hawaii: { name: 'Hawaii State Legislature', scope: 'state' },
  maui_county_hi: { name: 'Maui County Council', scope: 'county' },
  kauai_county_hi: { name: 'Kauai County Council', scope: 'county' },
  honolulu_hi: { name: 'Honolulu City Council', scope: 'municipal' },
  hawaii_county_hi: { name: 'Hawaii County Council', scope: 'county' },
  johnson_county_ia: { name: 'Johnson County Board of Supervisors', scope: 'county' },
  linn_county_ia: { name: 'Linn County Board of Supervisors', scope: 'county' },
  polk_county_ia: { name: 'Polk County Board of Supervisors', scope: 'county' },
  warren_county_ia: { name: 'Warren County Board of Supervisors', scope: 'county' },
  woodbury_county_ia: { name: 'Woodbury County Board of Supervisors', scope: 'county' },
  davenport_ia: { name: 'Davenport City Council', scope: 'municipal' },
  iowa_city_ia: { name: 'Iowa City Council', scope: 'municipal' },
  iowa: { name: 'Iowa Legislature', scope: 'state' },
  des_moines_ia: { name: 'Des Moines City Council', scope: 'municipal' },
  cedar_rapids_ia: { name: 'Cedar Rapids City Council', scope: 'municipal' },
  sioux_city_ia: { name: 'Sioux City Council', scope: 'municipal' },
  duluth_mn: { name: 'Duluth City Council', scope: 'municipal' },
  hennepin_county_mn: { name: 'Hennepin County Board of Commissioners', scope: 'county' },
  olmsted_county_mn: { name: 'Olmsted County Board of Commissioners', scope: 'county' },
  ramsey_county_mn: { name: 'Ramsey County Board of Commissioners', scope: 'county' },
  dakota_county_mn: { name: 'Dakota County Board of Commissioners', scope: 'county' },
  louisville_ky: { name: 'Louisville Metro Council', scope: 'municipal' },
  lexington_ky: { name: 'Lexington-Fayette Urban County Council', scope: 'municipal' },
  bowling_green_ky: { name: 'Bowling Green City Commission', scope: 'municipal' },
  warren_county_ky: { name: 'Warren County, Kentucky Fiscal Court', scope: 'county' },
  kentucky: { name: 'Kentucky General Assembly', scope: 'state' },
  memphis_tn: { name: 'Memphis City Council', scope: 'municipal' },
  allen_county_in: { name: 'Allen County Board of Commissioners & County Council', scope: 'county' },
  evansville_in: { name: 'Evansville City Council', scope: 'municipal' },
  frederick_md: { name: 'Frederick City Council', scope: 'municipal' },
  south_bend_in: { name: 'South Bend Common Council', scope: 'municipal' },
  vanderburgh_county_in: { name: 'Vanderburgh County Board of Commissioners & County Council', scope: 'county' },
  st_joseph_county_in: { name: 'St. Joseph County Council', scope: 'county' },
  fishers_in: { name: 'Fishers City Council', scope: 'municipal' },
  indianapolis_in: { name: 'Indianapolis City-County Council', scope: 'municipal' },
  fort_wayne_in: { name: 'Fort Wayne Common Council', scope: 'municipal' },
  hamilton_county_in: { name: 'Hamilton County Government (Indiana)', scope: 'county' },
  akron_city_council: { name: 'Akron City Council', scope: 'municipal' },
  omaha_ne: { name: 'Omaha City Council', scope: 'municipal' },
  lincoln_ne: { name: 'Lincoln City Council', scope: 'municipal' },
  grand_island_ne: { name: 'Grand Island City Council', scope: 'municipal' },
  essex_county_nj: { name: 'Essex County Board of Commissioners', scope: 'county' },
  jersey_city_nj: { name: 'Jersey City Municipal Council', scope: 'municipal' },
  mercer_county_nj: { name: 'Mercer County Board of County Commissioners', scope: 'county' },
  hudson_county_nj: { name: 'Hudson County Board of County Commissioners', scope: 'county' },
  trenton_nj: { name: 'Trenton City Council', scope: 'municipal' },
  paterson_city_council: { name: 'Paterson City Council', scope: 'municipal' },
  onondaga_county_ny: { name: 'Onondaga County Legislature', scope: 'county' },
  cuyahoga_county_oh: { name: 'Cuyahoga County Council', scope: 'county' },
  summit_county_oh: { name: 'Summit County Council', scope: 'county' },
  delaware_county_oh: { name: 'Delaware County Board of Commissioners', scope: 'county' },
  fairfield_county_oh: { name: 'Fairfield County Board of Commissioners, OH', scope: 'county' },
  lucas_county_oh: { name: 'Lucas County Board of County Commissioners', scope: 'county' },
  montgomery_county_oh: { name: 'Montgomery County, OH', scope: 'county' },
  franklin_county_oh: { name: 'Franklin County, OH', scope: 'county' },
  montgomery_county_md: { name: 'Montgomery County, MD', scope: 'county' },
  lane_county_or: { name: 'Lane County Board of Commissioners, OR', scope: 'county' },
  multnomah_county_or: { name: 'Multnomah County Board of County Commissioners, OR', scope: 'county' },
  marion_county_or: { name: 'Marion County Board of Commissioners, OR', scope: 'county' },
  washington_county_or: { name: 'Washington County Board of Commissioners, OR', scope: 'county' },
  clackamas_county_or: { name: 'Clackamas County Board of County Commissioners, OR', scope: 'county' },
  allegheny_county_pa: { name: 'Allegheny County Council, PA', scope: 'county' },
  berks_county_pa: { name: 'Berks County Commissioners, PA', scope: 'county' },
  lackawanna_county_pa: { name: 'Lackawanna County Board of Commissioners, PA', scope: 'county' },
  lehigh_county_pa: { name: 'Lehigh County Board of Commissioners, PA', scope: 'county' },
  reading_pa: { name: 'Reading, PA City Council', scope: 'municipal' },
  scranton_pa: { name: 'Scranton City Council', scope: 'municipal' },
  chandler_az: { name: 'Chandler City Council', scope: 'municipal' },
  tucson_az: { name: 'Tucson Mayor and Council', scope: 'municipal' },
  idaho: { name: 'Idaho Legislature', scope: 'state' },
  indiana: { name: 'Indiana General Assembly', scope: 'state' },
  colorado: { name: 'Colorado General Assembly', scope: 'state' },
  florida: { name: 'Florida Legislature', scope: 'state' },
  georgia: { name: 'Georgia General Assembly', scope: 'state' },
  texas: { name: 'Texas Legislature', scope: 'state' },
  massachusetts: { name: 'Massachusetts General Court', scope: 'state' },
  maryland: { name: 'Maryland General Assembly', scope: 'state' },
  missouri: { name: 'Missouri General Assembly', scope: 'state' },
  mississippi: { name: 'Mississippi Legislature', scope: 'state' },
  michigan: { name: 'Michigan Legislature', scope: 'state' },
  nevada: { name: 'Nevada Legislature', scope: 'state' },
  montana: { name: 'Montana Legislature', scope: 'state' },
  billings_mt: { name: 'Billings City Council', scope: 'municipal' },
  missoula_mt: { name: 'Missoula City Council', scope: 'municipal' },
  yellowstone_county_mt: { name: 'Yellowstone County Board of County Commissioners, MT', scope: 'county' },
  bozeman_mt: { name: 'Bozeman City Commission', scope: 'municipal' },
  gallatin_county_mt: { name: 'Gallatin County Commission', scope: 'county' },
  missoula_county_mt: { name: 'Missoula County Board of County Commissioners', scope: 'county' },
  nebraska: { name: 'Nebraska Legislature', scope: 'state' },
  north_carolina: { name: 'North Carolina Legislature', scope: 'state' },
  south_carolina: { name: 'South Carolina General Assembly', scope: 'state' },
  new_hampshire: { name: 'New Hampshire General Court', scope: 'state' },
  new_jersey: { name: 'New Jersey Legislature', scope: 'state' },
  new_mexico: { name: 'New Mexico Legislature', scope: 'state' },
  new_york: { name: 'New York State Legislature', scope: 'state' },
  north_dakota: { name: 'North Dakota Legislative Assembly', scope: 'state' },
  south_dakota: { name: 'South Dakota Legislature', scope: 'state' },
  tennessee: { name: 'Tennessee General Assembly', scope: 'state' },
  ohio: { name: 'Ohio General Assembly', scope: 'state' },
  oklahoma: { name: 'Oklahoma Legislature', scope: 'state' },
  rhode_island: { name: 'Rhode Island General Assembly', scope: 'state' },
  pennsylvania: { name: 'Pennsylvania General Assembly', scope: 'state' },
  virginia: { name: 'Virginia General Assembly', scope: 'state' },
  west_virginia: { name: 'West Virginia Legislature', scope: 'state' },
  wyoming: { name: 'Wyoming State Legislature', scope: 'state' },
  washington: { name: 'Washington State Legislature', scope: 'state' },
  vermont: { name: 'Vermont General Assembly', scope: 'state' },
}

export function getProviderDisplayName(provider: string | null | undefined): string {
  const normalized = String(provider || '').trim()
  return PROVIDER_META[normalized]?.name || normalized || 'Unknown provider'
}

export function getProviderScope(provider: string | null | undefined): 'federal' | 'state' | 'county' | 'municipal' | null {
  const normalized = String(provider || '').trim()
  return PROVIDER_META[normalized]?.scope || null
}
